import styled from 'styled-components'
import homeTexture from 'resources/images/texture.jpg'

export const Container = styled.div`
  padding: 0;
  min-height: 100vh;
  overflow: hidden;
`

export const Wrapper = styled.div`
  background: url(${homeTexture});
  background-repeat: repeat;
  background-size: 100%;
`
